export default "__VITE_ASSET__C0SB08Fi__"